/* import __COLOCATED_TEMPLATE__ from './workflow-trigger-selector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();